import { cn } from "@/lib/utils"

type ToolResultCardProps = {
  label: string
  value: string | number
  sublabel?: string
  variant?: "default" | "primary" | "success" | "warning" | "danger"
  className?: string
}

const variantStyles = {
  default: "border-neutral-200 dark:border-neutral-800",
  primary: "border-brand-button/30 bg-blue-50/50 dark:bg-blue-900/10",
  success: "border-green-300/50 bg-green-50/50 dark:bg-green-900/10",
  warning: "border-yellow-300/50 bg-yellow-50/50 dark:bg-yellow-900/10",
  danger: "border-red-300/50 bg-red-50/50 dark:bg-red-900/10",
}

const valueStyles = {
  default: "text-neutral-900 dark:text-white",
  primary: "text-brand-button",
  success: "text-green-600 dark:text-green-400",
  warning: "text-yellow-600 dark:text-yellow-400",
  danger: "text-red-600 dark:text-red-400",
}

export default function ToolResultCard({
  label,
  value,
  sublabel,
  variant = "default",
  className,
}: ToolResultCardProps) {
  return (
    <div
      className={cn(
        "rounded-xl border p-4 bg-white dark:bg-neutral-900/50 text-center",
        variantStyles[variant],
        className
      )}
    >
      <p className="text-xs font-semibold text-neutral-500 dark:text-neutral-400 uppercase tracking-wider mb-1">
        {label}
      </p>
      <p className={cn("text-2xl sm:text-3xl font-bold", valueStyles[variant])}>
        {value}
      </p>
      {sublabel && (
        <p className="text-xs text-neutral-400 dark:text-neutral-500 mt-1 font-medium">
          {sublabel}
        </p>
      )}
    </div>
  )
}
